<template>
  <div>
    <top-header></top-header>
    <div class="container">
      <nav-list :navList="navList" @toHome="toHome" v-show="isShow"></nav-list>
      <div class="hint" v-show="showSuccess">您已成功提交【遗体接运】登记信息</div>
      <el-button type="primary" v-show="!isShow" @click="toIndex" style="float:right;font-size:20px;">返回首页</el-button>
      <router-view></router-view>
    </div>
    <bootm-footer></bootm-footer>
  </div>
</template>

<script>
import topHeader from "@/components/topHeader.vue";
import navList from "@/components/nav.vue";
import bootmFooter from "@/components/footer.vue";

export default {
  components: { topHeader, navList, bootmFooter },
  data() {
    return {
		showSuccess:false,
      isShow: true,
      toPath: "",
      navList: [
        {
          img: require("@/assets/img/nav1.png"),
          name: "遗体接运",
          path: "/",
        },
        {
          img: require("@/assets/img/nav2.png"),
          name: "身后一件事",
          path: "/oneThing",
        },
      ],
    };
  },
  computed: {},
  watch: {
    "$route.path"(toPath, fromPath) {
      console.log("路由变化了");
      console.log("当前页面路由地址：" + toPath);
      console.log("上一个路由地址：" + fromPath);
      this.toPath = toPath;
      if (
        this.toPath == "/" ||
        this.toPath == "/bodyTransfer" ||
        this.toPath == "/oneThing"
      ) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
  },
  methods: {
    toHome(e) {
      this.$router.push({
        path: "/bodyTransfer",
        query: e,
      });
    },
    toIndex(){
      this.$router.push({
        path: "/"
      });
    }
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>
